import { createGlobalStyle } from 'styled-components';

const GlobalStyles = createGlobalStyle`
    :root {
        --red: #FF4949;
        --black: #2E2E2E;
        --yellow: #ffc600;
        --white: #fff;
        --grey: #5c5c5c;
        --bg: #20133e;
        --font: #d5d5d5;
        --text-color-light: #222;
        --text-color-dark: #ddd;
        color-scheme: light dark;
    }
    
    html {
        background-attachment: fixed;
        font-size: 18px;
        background-color: var(--bg);
        scrollbar-width: thin;
        scrollbar-color: var(--red) var(--white);
    }

    fieldset {
        border-color: rgba(0, 0, 0, 0.1);
        border-width: 1px;
    }

    .gatsby-image-wrapper img[src*=base64\\,] {
        image-rendering: -moz-crisp-edges;
        image-rendering: pixelated;
    }

    /* Scrollbar Styles */
    body::-webkit-scrollbar {
        width: 12px;
    }
    
    body::-webkit-scrollbar-track {
        background: var(--white);
    }

    body::-webkit-scrollbar-thumb {
        background-color: var(--red);
        border-radius: 6px;
        border: 3px solid var(--white);
    }

    hr {
        border: 0;
        height: 8px;
        background-size: 1500px;
    }

    img {
        max-width: 100%;
    }
    
    h1 {
        font-weight: bold;
        font-size: 25px;
    }
    
`;

export default GlobalStyles;